export default {
  sidebarRecords: [], // Array of records for the current sidebar,
  sidebarSearch: '', // Value of the sidebar search field (string)
  sidebarTags: [], // Array of currently selected tags in the sidebar filter
  isSideBarOpen: true, // If true, app side bar will open
  spinnerMessage: null, // If set, an app spinner will appear with the specified message displayed below it (see actions > showSpinner() )
  confirm: null, // If set, a modal confirmation message box will appear. See actions > confirm() for details of how this object is set.
  width: 0, // When the viewport width changes it is stored here so that it can be used in template logic if necessary (set by App.vue > onResize() method)
  height: 0, // When the viewport height changes it is stored here so that it can be used in template logic if necessary (set by App.vue > onResize() method)
  quickViewPanelWidth: 1024
}
